/* eslint-disable no-alert */
// 位置情報に外部からデータを送信する

/*-------------------
    モジュールのimport
---------------------*/
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import axios from 'axios';
import { MapContainer, TileLayer, Marker } from 'react-leaflet';
import { icon } from 'leaflet';
import ReactLeafletGoogleLayer from 'react-leaflet-google-layer';
import imageCompression from 'browser-image-compression';
// import { saveAs } from 'file-saver';

/*-------------------
    cssのimport
---------------------*/
import './css/post.css';
import 'leaflet/dist/leaflet.css';
import 'leaflet-gesture-handling';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
/*-------------------
    画像のimport
---------------------*/
import iconMarker from 'leaflet/dist/images/marker-icon.png';
import imgLoading from './images/icon/loading_w.png';

/*-------------------
    classのimport
---------------------*/
import * as commons from './commons';
import MyComponent from './components/UseMapEvents';
import Footer from './components/Footer';

import { API_PATH, EVA_PATH } from './constant/constant';

// クラス名
class PostSend extends Component {
  constructor(props) {
    super(props);

    document.title = `投稿フォーム`;

    // URLを取得。
    const url = props.location.pathname;
    // 市町村を取得する。
    const num = url.lastIndexOf('/');
    const lgCrypt = url.slice(num + 1);

    this.state = {
      lgCrypt,
      resultFlag: '0',
      searchAddress: '',
      pointList: [],
      selectKindList: [],
      kindList: [],
      compressFlag: false,
      // 入力項目関連
      title: '',
      main: '',
      markerPositon: [],
      fileNameList: [],
      fileDataArray: [],
      urlList: [''],
      kind: '',
      // 以下、地図用
      iconUrl: '',
      mapFlag: '0',
      mapPositon: [],
      mapZoom: 15,
      mapKey: commons.randomNum(),
      tileAttribution: '',
      tileUrl: '',
      marker: [],
    };
  }

  componentDidMount = async () => {
    const { lgCrypt } = this.state;
    const { lgCd, permission = 0 } = await commons.getLgCd(lgCrypt);
    if (lgCd === '') {
      this.setState({ resultFlag: '20' });
      return;
    }
    this.getSetting(lgCd, permission);

    // 以下、ドロップエリア用
    // アップロードエリアの要素を取得。
    const uploadAreaElem = document.getElementById('upload-area');

    // 指定エリアにドロップされた場合の処理
    uploadAreaElem.addEventListener('drop', (e) => {
      uploadAreaElem.className = 'btn Form-Img point';
      const { length = 0 } = e.dataTransfer.files;
      if (length === 0) return;
      this.getImage(e.dataTransfer.files);
    });

    let a = new Date().getTime();
    // 画面上のどこかにドラッグされると動く
    document.addEventListener('dragover', (e) => {
      uploadAreaElem.className = 'drop';
      e.preventDefault();
      a = new Date().getTime();
      setTimeout(() => {
        // 最終dragover発火時間から2秒経過している場合は元に戻す。
        if (new Date().getTime() - a > 1000) {
          uploadAreaElem.className = 'btn Form-Img point';
        }
      }, 1 * 1000);
    });

    // 指定エリア外でドロップすると動く。
    document.addEventListener('drop', (e) => {
      e.preventDefault();
    });
  };

  /**
   * 設定情報を取得する。
   *
   * @memberof PostSend
   */
  getSetting = async (lgCd, permission) => {
    // 地図の設定を取得
    const mapSetting = await axios
      .post(`${API_PATH}/v/com`, { kind: '1', collectionName: 'M_URL_SETTING' })
      .then((res) => res.data)
      .catch(() => {
        window.alert('データの取得に失敗しました。');
        return [];
      });
    const { map_url: mapUrl = '', other = '' } = mapSetting[0];
    const { tile_url: tileUrl = '', tile_attribution: tileAttribution = '' } = mapUrl;
    const { cod_check: codCheckUrl = '' } = other;

    // 地方公共団体の情報を取得
    const lclSetting = await axios
      .post(`${API_PATH}/v/com`, { kind: '1', collectionName: 'M_LCL_SETTING', lgCd })
      .then((res) => res.data)
      .catch(() => {
        window.alert('データの取得に失敗しました。');
        return [];
      });
    if (lclSetting.length === 0) {
      this.setState({
        resultFlag: '20',
      });
      return;
    }

    const {
      center_point: latLng = [],
      center_zoom: centerZoom = 15,
      post_resident: postResident = '',
      public_map: publicMap = '',
      lcl_gov: lclGov = '',
    } = lclSetting[0];
    const { lg_name: lgName = '', pref_cd: prefCd = '', pref_name: prefName = '' } = lclGov;
    const {
      title = '',
      public_flag: publicFlag = false,
      kind_list: kindList = [],
      default_title: tmpTitle = '',
      compress_value: compressValue = 1.5,
      permission: postPermission = 7,
    } = postResident;
    const { icon_url: iconUrl = '' } = publicMap;

    if (postPermission > permission) {
      this.setState({ resultFlag: '20' });
      return;
    }

    const defaultTitle = tmpTitle.replace(
      '$date',
      commons.changeJapanDate(new Date(), 'YYYY年MM月DD日 hh時mm分')
    );

    if (title === '') {
      this.setState({ resultFlag: '20' });
      return;
    }

    document.title = title; // タブのタイトルを設定する。

    // faviconの変更
    if (iconUrl !== '') {
      const link = document.querySelector("link[rel~='icon']");
      link.href = iconUrl;
    }

    // 種別リスト作成
    const tmpKindList = [];
    for (let i = 0; i < kindList.length; i += 1) {
      const { name } = kindList[i];
      tmpKindList.push({ value: i, label: name });
    }
    if (kindList.length > 0) tmpKindList.push({ value: '', label: 'その他' });

    // 市町村コードから中心座標を取得する。
    this.setState({
      lgCd,
      iconUrl,
      mapPositon: latLng,
      mapZoom: centerZoom,
      formTitle: title,
      publicFlag,
      tileAttribution,
      tileUrl,
      codCheckUrl,
      lgName,
      prefCd,
      prefName,
      selectKindList: tmpKindList,
      kindList,
      kind: kindList.length === 0 ? '' : 0,
      title: defaultTitle,
      compressValue,
    });
  };

  /**
   * マップクリック時の処理
   * @memberof PostSend
   */
  onMapClick = (e) => {
    const { lat = '', lng = '' } = e;
    this.setState({
      marker: this.createMarker([lat, lng]),
      markerPositon: [lat, lng],
    });
  };

  /**
   * マーカー作成する。
   *
   * @memberof PostSend
   */
  createMarker = (latLng) => {
    const markerIcon = icon({
      iconUrl: iconMarker,
      iconSize: [25, 41],
      iconAnchor: [12.5, 41],
    });
    const marker = <Marker position={latLng} icon={markerIcon} />;
    return marker;
  };

  /**
   * 画像の削除処理
   *
   * @memberof PostSend
   */
  onClickBtnDel = (num, kind) => {
    const { urlList, fileDataArray } = this.state;
    if (kind === '0') {
      fileDataArray.splice(num, 1);
      const resDisp = this.dispImage(fileDataArray);
      const { fileNameList } = resDisp;
      this.setState({ fileDataArray, fileNameList });
    } else if (kind === '1') {
      urlList.splice(num, 1);
      this.setState([urlList]);
    }
  };

  /**
   * ファイルをJpeg形式に変換する
   * @param {File} file 変換するファイル
   * @returns {Promise<string>} Base64形式のデータURL
   */
  convertToJpeg = async (file) =>
    new Promise((resolve) => {
      const image = new Image();
      image.src = URL.createObjectURL(file);

      image.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Canvasに画像を描画
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        // JPEGに変換したBlobを取得
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const jpegFile = new File([blob], file.name.replace(/\.\w+$/, '.jpeg'), {
                type: 'image/jpeg',
                lastModified: Date.now(),
              });
              resolve(jpegFile);
            } else {
              window.alert(`${file.name}のJPEG変換に失敗しました`);
              resolve(false);
            }
          },
          'image/jpeg',
          1
        ); // 変換後のJPEG画像の品質（0〜1）を指定
      };

      image.onerror = () => {
        window.alert(`${file.name}の読み込みに失敗しました`);
        resolve(false);
      };
    });

  /**
   * ファイルをBase64形式に変換する
   * @param {File} file 変換するファイル
   * @returns {Promise<string>} Base64形式のデータURL
   */
  fileToBase64 = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64Data = reader.result.split(',')[1];
        resolve({
          name: file.name,
          data: base64Data,
          lastModified: file.lastModified,
          type: file.type,
        });
      };
      reader.onerror = () => {
        resolve(false);
      };
      reader.readAsDataURL(file);
    });

  /**
   * 画像を圧縮する
   * @param {File} file 圧縮前の画像ファイル
   * @returns {Promise<File>} 圧縮後の画像ファイル
   */
  compressImage = async (file) => {
    const { compressValue } = this.state;
    let imageFile = file;
    if (file.type !== 'image/jpeg') {
      imageFile = (await this.convertToJpeg(file)) || false;
    }
    if (imageFile === false) return false;

    const options = {
      maxSizeMB: compressValue, // 最大サイズを設定
      useWebWorker: true, // Web Workerを有効にする（デフォルトで有効）
      maxWidthOrHeight: 4096, // 最大解像度
      initialQuality: 1, // 圧縮品質
    };
    try {
      return await imageCompression(imageFile, options);
    } catch (error) {
      window.alert(`${file.name}の圧縮に失敗しました`);
      return false;
    }
  };

  /**
   * 画像ファイルを処理する
   * @param {File} file 画像ファイル
   * @returns {Promise<string>} 圧縮またはそのままのBase64形式の画像
   */
  processImage = async (file) => {
    const { compressValue: maxSizeMB = 1.5 } = this.state;
    const fileSizeMB = file.size / (1024 * 1024); // ファイルサイズをMBに変換

    if (fileSizeMB > maxSizeMB) {
      // 画像アップロード中メッセージを出す。
      this.setState({
        compressFlag: true,
      });

      // 1MBを超える場合、画像を圧縮してBase64に変換
      const compressedFile = await this.compressImage(file);
      // saveAs(compressedFile, `${new Date().getTime()}.jpg`); // 好きなファイル名と拡張子を指定
      if (compressedFile === false) return false;
      return this.fileToBase64(compressedFile);
    }
    // 1MB以下の場合、そのままBase64に変換
    return this.fileToBase64(file);
  };

  /**
   * 画像の表示欄を作成する。
   *
   * @memberof PostSend
   */
  dispImage = (imageFile) => {
    const fileNameList = [];
    const errList = [];
    let count = 0;
    for (let i = 0; i < imageFile.length; i += 1) {
      const { type = '', name, lastModified: tmpLastModified } = imageFile[i];

      const format = type.split('/')[0];
      if (format !== 'image') {
        errList.push(`添付ファイル(${name})が画像形式ではありません。`);
      } else {
        const tmpCount = count;
        const lastModified = commons.changeJapanDate(tmpLastModified, 'YYYY年MM月DD日 hh時mm分');
        fileNameList.push(
          <div key={`${i}`}>
            <button
              type="button"
              className="btnDelete"
              onClick={() => this.onClickBtnDel(tmpCount, '0')}
            >
              {''}
            </button>
            <div className="txtSmall mt10" style={{ display: 'inline-block' }}>
              &emsp;
              {`${name.replace(/\..*/, '')} (${lastModified})`}
            </div>
          </div>
        );
        count += 1;
      }
    }

    if (errList.length !== 0) {
      window.alert(errList.toString().replace(/,/g, '\n'));
      return false;
    }

    return {
      fileNameList,
    };
  };

  /**
   * 画像添付する。
   *
   * @memberof PostSend
   */
  getImage = async (imageFile) => {
    if (imageFile.length > 5) {
      window.alert('添付するファイルは5枚以下にして下さい。');
      this.setState({
        fileDataArray: [],
        fileNameList: [],
      });
      return false;
    }

    const resDisp = this.dispImage(imageFile);
    if (resDisp === false) return false;

    // 配列で持っているファイルデータをbase64に変換する。
    // Promise.allで並列処理
    const fileDataArray = await Promise.all(
      Array.from(imageFile).map((file) => this.processImage(file))
    );

    const { fileNameList: resFileNameList } = resDisp;

    const tmpDataArray = [];
    const tmpFileName = [];
    for (let i = 0; i < fileDataArray.length; i += 1) {
      if (fileDataArray[i] === false) continue;
      tmpDataArray.push(fileDataArray[i]);
      tmpFileName.push(resFileNameList[i]);
    }

    this.setState({
      fileDataArray: tmpDataArray,
      fileNameList: tmpFileName,
      compressFlag: false,
    });
    return true;
  };

  /**
   * URLテキストをsetState
   *
   * @memberof PostSend
   */
  setUrlText = (num, value) => {
    const { urlList } = this.state;
    urlList[num] = value;
    this.setState({
      urlList,
    });
  };

  /**
   * URL入力欄を作成
   *
   * @memberof PostSend
   */
  createUrlList = (urlList) => {
    const tmpUrlList = [];
    for (let i = 0; i < urlList.length; i += 1) {
      tmpUrlList.push(
        <div className="Form-Flex mb10" key={`url_${i}`}>
          <input
            type="text"
            className="Form-Item-Input"
            value={urlList[i]}
            onChange={(e) => this.setUrlText(i, e.target.value)}
          />
          {i === 0 ? (
            <span style={{ width: '24px' }} />
          ) : (
            <button
              type="button"
              className="btnDelete"
              onClick={() => this.onClickBtnDel(i, '1')}
              style={{ marginTop: '12px' }}
            >
              {''}
            </button>
          )}
        </div>
      );
    }

    return tmpUrlList;
  };

  /**
   * URLを追加
   *
   * @memberof PostSend
   */
  addUrl = () => {
    const { urlList } = this.state;
    urlList.push('');
    this.setState({
      urlList,
    });
  };

  /**
   * 検索時のリスト作成
   * @memberof PostSend
   */
  createPointList = (point) => {
    const tmpList = [];
    for (let i = 0; i < point.length; i += 1) {
      const { geometry = '', properties = '' } = point[i];
      const { coordinates = '' } = geometry;
      const { title = '' } = properties;

      tmpList.push(
        <div key={commons.randomNum()}>
          <input
            type="submit"
            className="btn btnOutlineDefault"
            value={title}
            onClick={() => {
              this.setState({
                marker: this.createMarker([coordinates[1], coordinates[0]]),
                markerPositon: [coordinates[1], coordinates[0]],
                mapPositon: [coordinates[1], coordinates[0]],
                mapKey: commons.randomNum(),
              });
            }}
          />
        </div>
      );
    }
    this.setState({
      pointList: tmpList,
    });
  };

  /**
   * 座標検索
   * @memberof PostSend
   */
  searchCordinate = async () => {
    const { searchAddress, codCheckUrl } = this.state;
    // 住所検索の場合
    const point = await commons.addressToPoint(searchAddress, codCheckUrl);

    if (point === false) {
      window.alert('座標の変換に失敗しました。');
      return;
    }
    if (point.length === 0) {
      window.alert('結果が存在しませんでした。');
      return;
    }

    if (point.length > 30) {
      window.alert('候補が多ぎます。\nもう少し詳細な情報を入力して下さい。');
      return;
    }

    if (point.length === 1) {
      const { geometry = '' } = point[0];
      const { coordinates = '' } = geometry;

      this.setState({
        marker: this.createMarker([coordinates[1], coordinates[0]]),
        markerPositon: [coordinates[1], coordinates[0]],
        mapPositon: [coordinates[1], coordinates[0]],
        mapKey: commons.randomNum(),
      });
      return;
    }
    this.createPointList(point);
  };

  /**
   * 送信用
   *
   * @memberof PostSend
   */
  send = async () => {
    const {
      publicFlag,
      title,
      main,
      markerPositon,
      urlList,
      lgCd,
      lgName,
      prefCd,
      prefName,
      kind,
      kindList,
      fileDataArray,
    } = this.state;

    const errList = [];

    if (title === '') {
      errList.push('タイトルが未入力です。');
    }
    if (markerPositon.length === 0) {
      errList.push('座標が未入力です。');
    }

    if (errList.length !== 0) {
      window.alert(errList.toString().replace(/,/g, '\n'));
      return false;
    }

    this.setState({
      resultFlag: '30',
    });

    // 設定している色を取得する。
    let color = '#ffffff';
    let backColor = '0,0,0,0.8';
    let kindName = 'その他';
    let markerImg = '';
    if (kind === '') {
      // Nothing
    } else {
      const {
        color: tmpColor = '',
        back_color: tmpBackColor = '',
        name,
        img = '',
      } = kindList[kind];
      color = tmpColor;
      backColor = tmpBackColor;
      markerImg = img;
      kindName = name;
    }

    // トランデータ用のIDを先に取得する(画像名につけたいため)。
    const dataId = await axios
      .post(`${EVA_PATH}/p/v1/prs/c/seq`, {})
      .then((res) => res.data)
      .catch(() => {
        window.alert('エラーが発生しました。');
        return false;
      });

    if (dataId === false) return false;

    // 画像ファイルがあれば先に投げる
    const promise = []; // プロミス用の箱

    for (let i = 0; i < fileDataArray.length; i += 1) {
      promise.push(this.sendFile(fileDataArray[i], dataId, lgCd));
    }

    // 画像ファイルが全て投げ終わるまで待つ。
    const resSendFile = await Promise.all(promise);

    const filenameArray = [];
    const fileInfoArray = [];
    for (let i = 0; i < fileDataArray.length; i += 1) {
      const { name = '', lastModified = '' } = fileDataArray[i];

      if (resSendFile[i] === false) {
        errList.push(`${name}の送信に失敗しました。`);
        continue;
      }

      filenameArray.push(`${dataId}_${name}`);
      fileInfoArray.push({
        name: `${dataId}_${name}`,
        date: commons.changeJapanDate(parseInt(lastModified, 10), 'YYYY年MM月DD日 hh時mm分'),
        public: true,
        enable: true,
      });
    }

    if (errList.length !== 0) {
      window.alert(errList.toString().replace(/,/g, '\n'));
    }

    const res = await axios
      .post(`${EVA_PATH}/p/v1/prs/c`, {
        title,
        main,
        point: markerPositon,
        urlList,
        lgCd,
        lgName,
        prefCd,
        prefName,
        color,
        backColor,
        kindName,
        dataId,
        publicFlag,
        markerImg,
        filenameArray,
        fileInfoArray,
      })
      .catch(() => false);

    if (res === false) {
      this.setState({
        resultFlag: '0',
      });
      window.alert('エラーが発生しました。');
      return false;
    }

    this.setState({
      resultFlag: '10',
    });
    return true;
  };

  /**
   * 画像ファイルの送信を行う。
   *
   * @memberof PostSend
   */
  sendFile = async (fileData = false, dataId, lgCd) => {
    if (fileData === false) return false;

    const res = await axios
      .post(`${EVA_PATH}/p/v1/prs/c/img`, {
        lgCd,
        dataId,
        fileData,
      })
      .then(() => true)
      .catch(() => false);
    return res;
  };

  /**
   * 現在地の取得を行う。
   *
   * @memberof PostSend
   */
  getCurrentCod = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          // 位置情報の取得に成功した場合の処理
          const { coords = '' } = position;
          const { latitude: lat = '', longitude: lng = '' } = coords;

          this.setState({
            marker: this.createMarker([lat, lng]),
            markerPositon: [lat, lng],
            mapPositon: [lat, lng],
            mapKey: commons.randomNum(),
          });
        },
        () => {
          // 位置情報の取得に失敗した場合の処理
          window.alert('現在地の取得に失敗しました。');
          return false;
        }
      );
    } else {
      window.alert('このブラウザでは地理位置情報がサポートされていません。');
    }
  };

  // 画面遷移用
  movePage = () => {
    const { history } = this.props;
    const { lgCrypt } = this.state;
    history.push({
      pathname: '/empty_page',
      path: `./post/send/${lgCrypt}`,
    });
  };

  /**
   * テスト用
   *
   * @memberof PostSend
   */
  test = () => {};

  render() {
    const {
      resultFlag,
      iconUrl,
      formTitle,
      title,
      mapFlag,
      mapPositon,
      mapZoom,
      mapKey,
      tileAttribution,
      tileUrl,
      marker,
      fileNameList,
      urlList,
      selectKindList,
      pointList,
      compressFlag,
      compressValue = 1.5,
    } = this.state;

    return (
      <div id="container">
        {resultFlag === '0' ? (
          <div style={{ display: mapPositon.length === 0 ? 'none' : '' }}>
            <div className="header-content">
              {iconUrl === '' ? null : <img className="site-icon" src={iconUrl} alt="" />}
              {formTitle}
            </div>
            <div className="Form">
              {selectKindList.length === 0 ? null : (
                <div className="Form-Item" style={{ borderTop: '0px', paddingTop: '0px' }}>
                  <p className="Form-Item-Label">
                    <span className="required">情報種別</span>
                  </p>
                  <select
                    className="Form-Item-select"
                    onBlur={(e) => {
                      this.setState({ kind: e.target.value });
                    }}
                  >
                    {selectKindList.map((d) => (
                      <option key={d.label} value={d.value}>
                        {d.label}
                      </option>
                    ))}
                  </select>
                </div>
              )}
              <div className="Form-Item">
                <p className="Form-Item-Label">
                  <span className="required">タイトル</span>
                </p>
                <input
                  type="text"
                  className="Form-Item-Input"
                  defaultValue={title}
                  onBlur={(e) =>
                    this.setState({
                      title: e.target.value,
                    })
                  }
                />
              </div>
              <div className="Form-Item">
                <p className="Form-Item-Label isMsg">本文</p>
                <textarea
                  className="Form-Item-Textarea"
                  onBlur={(e) =>
                    this.setState({
                      main: e.target.value,
                    })
                  }
                />
              </div>
              {mapPositon.length === 0 ? null : (
                <div className="Form-Item">
                  <p className="Form-Item-Label">
                    <span className="required">座標</span>
                  </p>
                  <div className="Form-Flex">
                    <div style={{ width: '100%' }} className="mb20">
                      <h2 className="hdg-l2">
                        地図&emsp;
                        <span>
                          <label htmlFor="map01">
                            <input
                              type="radio"
                              name="map"
                              id="map01"
                              checked={mapFlag === '10'}
                              onChange={() => this.setState({ mapFlag: '10' })}
                            />
                            &nbsp;GoogleMap
                          </label>
                        </span>
                        &emsp;
                        <span>
                          <label htmlFor="map02">
                            <input
                              type="radio"
                              name="map"
                              id="map02"
                              checked={mapFlag === '0'}
                              onChange={() => this.setState({ mapFlag: '0' })}
                            />
                            &nbsp;国土地理院
                          </label>
                        </span>
                      </h2>
                      <MapContainer
                        center={mapPositon}
                        zoom={mapZoom}
                        zoomControl // ズームコントローラーを非表示にできる。
                        boxZoom={false}
                        gestureHandling
                        className="Form-Map"
                        key={mapKey}
                      >
                        <MyComponent changeZoom="" onMoveEnd="" onMapClick={this.onMapClick} />
                        {mapFlag === '10' ? <ReactLeafletGoogleLayer /> : null}
                        {mapFlag === '11' ? <ReactLeafletGoogleLayer type="satellite" /> : null}
                        {mapFlag === '0' ? (
                          <TileLayer attribution={tileAttribution} url={tileUrl} />
                        ) : null}
                        {marker}
                      </MapContainer>
                    </div>
                    <div style={{ width: '100%' }} className="mb20">
                      <input
                        type="submit"
                        className="btn Form-Img point txtLarge"
                        value="現在地取得"
                        onClick={() => this.getCurrentCod()}
                      />
                    </div>
                    <div style={{ width: '100%' }} className="mb10">
                      <input
                        type="text"
                        className="Form-Item-date mr20"
                        placeholder="住所 役所 駅 施設"
                        onBlur={(e) =>
                          this.setState({
                            searchAddress: e.target.value,
                          })
                        }
                      />
                      <input
                        type="submit"
                        className="btn Form-Img point btnSearch txtLarge"
                        value="住所検索"
                        onClick={() => this.searchCordinate()}
                      />
                    </div>
                    {pointList.length === 0 ? null : <div>{pointList}</div>}
                  </div>
                </div>
              )}
              <div className="Form-Item">
                <p className="Form-Item-Label">画像</p>
                <div className="Form-Flex">
                  <div style={{ width: '100%' }}>
                    <input
                      id="upload-area"
                      type="submit"
                      className="btn Form-Img point txtLarge"
                      value="ファイル添付"
                      // 以下は、input="file"を押下した際の処理を走らせる。
                      onClick={() => document.getElementById('upload-form-fileselect').click()}
                    />
                    <span className="ml20 txtSmall">
                      ※{compressValue}MBを超える画像は圧縮して送信されます。
                    </span>
                    <input
                      id="upload-form-fileselect"
                      type="file"
                      accept="image/*,.png,.jpg,.jpeg,.gif"
                      onChange={(e) => this.getImage(e.target.files)}
                      style={{ display: 'none' }} // 表示しない
                      multiple
                    />
                  </div>
                  <div className="mt10">{fileNameList}</div>
                </div>
              </div>
              <div className="Form-Item">
                <p className="Form-Item-Label">
                  参考URL&emsp;
                  <input
                    type="submit"
                    className="btn btnOutlineDefault"
                    value="+ 追加"
                    onClick={() => this.addUrl()}
                  />
                </p>
                <div className="Form-Flex">{this.createUrlList(urlList)}</div>
              </div>
              <input
                type="submit"
                className="Form-Btn mt20 mb20"
                value="送信する"
                onClick={() => this.send()}
              />
            </div>
          </div>
        ) : null}
        {resultFlag === '10' ? (
          <div className="thanksPage">
            <div className="header-content mb20">{formTitle}</div>
            <div>投稿が完了しました。</div>
            <div>情報のご投稿ありがとうございました。</div>
            <div>
              <input
                type="submit"
                className="btn btnBack point mt20"
                value="投稿フォームへ戻る"
                onClick={() => this.movePage()}
              />
            </div>
          </div>
        ) : null}
        {resultFlag === '20' ? (
          <div className="errPage">
            <div>404</div>
            <div>Not Found</div>
            <div>ページが見つかりませんでした。</div>
          </div>
        ) : null}
        {/* 以下、モーダル */}
        {resultFlag === '30' ? (
          <div className="modalBack">
            <div style={{ marginTop: '10px', fontSize: '2.2em', color: '#fff' }}>
              <img
                src={imgLoading}
                alt=""
                style={{
                  display: 'block',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              />
              送信中
            </div>
          </div>
        ) : null}
        {compressFlag === true ? (
          <div className="modalBack">
            <div style={{ marginTop: '10px', fontSize: '2.2em', color: '#fff' }}>
              <img
                src={imgLoading}
                alt=""
                style={{
                  display: 'block',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              />
              画像圧縮中
            </div>
          </div>
        ) : null}
        <Footer />
      </div>
    );
  }
}

PostSend.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
    pathname: PropTypes.string,
  }).isRequired,
  history: PropTypes.shape({}).isRequired,
};

export default withRouter(PostSend);
